import { useParams } from "react-router-dom";
import { db, functions, database } from "../firebase";
import {
  createContext,
  useReducer,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import { insert, remove, replace, move } from "../utils/pageactions";
import useStyles from "../utils/usestyles";
import { LoaderDisbatch } from "./loader";
const loadPage = functions.httpsCallable("loadPageData");
const savePage = functions.httpsCallable("savePage");

export const PageValue = createContext(null);
export const PageDisbatch = createContext(null);

export default function PageContext({ children }) {
  const { appId, type, pageId } = useParams();
  const deletes = useRef({});
  const reducer = useCallback(
    (state, action) => {
      const newState = { ...state };
      if (action.type === "set") {
        return action.value;
      } else if (action.type === "insert") {
        const newBlocks = insert(
          newState,
          action.block,
          action.path,
          action.after
        );
        return newBlocks;
      } else if (action.type === "remove") {
        deletes.current[action.block.id] = action.block;
        const newBlocks = remove(newState, action.path);
        return newBlocks;
      } else if (action.type === "replace") {
        const newBlocks = replace(newState, action.block, action.path);
        return newBlocks;
      } else if (action.type === "move") {
        const newBlocks = move(
          newState,
          action.block,
          action.from,
          action.to,
          action.after
        );
        return newBlocks;
      } else {
        return newState;
      }
    },
    [appId, type, pageId]
  );
  const [state, dispatch] = useReducer(reducer, null);

  const setLoader = useContext(LoaderDisbatch);
  const log = useRef([]);
  const getStyles = useStyles();

  useEffect(() => {
    if (appId && pageId) {
      setLoader(true);
      db.collection("apps")
        .doc(appId)
        .collection(type)
        .doc(pageId)
        .collection("components")
        .get()
        .then((snap) => {
          const components = snap.docs.map((doc) => {
            return { ...doc.data(), id: doc.id };
          });
          const pageComponent = components.find(
            (x) =>
              x.id === pageId ||
              x.component === "Page" ||
              x.component === "Component"
          );

          if (!pageComponent) {
            return;
          }
          const getChildren = (data) => {
            const _data = { ...data };

            _data.children = data.children.map((cid) => {
              const child = components.find((x) => x.id === cid);
              return getChildren(child);
            });

            return _data;
          };

          const page = getChildren(pageComponent);

          const newTree = getStyles(page);
          dispatch({ type: "set", value: newTree });
          setTimeout(() => {
            setLoader(false);
          }, 700);
        });
    }
  }, [appId, pageId]);

  // useEffect(() => {
  //   let timeout;
  //   if (appId && pageId && state) {
  //     timeout = setTimeout(() => {
  //       db.collection("apps")
  //         .doc(appId)
  //         .collection(type)
  //         .doc(pageId)
  //         .set(state, { merge: true });
  //     }, 3000);
  //     log.current = [...log.current, state];
  //   }

  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [state]);

  useEffect(() => {
    let timeout;
    if (appId && pageId && state) {
      timeout = setTimeout(() => {
        savePage({
          appId,
          type,
          pageId,
          data: state,
          deletes: deletes.current,
        }).catch((err) => {
          console.log(err);
        });
        deletes.current = {};
      }, 3000);
      log.current = [...log.current, state];
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [state]);

  useEffect(() => {
    if (state) {
      setLoader(false);
    }
  }, [state]);

  if (!state) {
    return null;
  }

  return (
    <PageValue.Provider value={state}>
      <PageDisbatch.Provider value={dispatch}>{children}</PageDisbatch.Provider>
    </PageValue.Provider>
  );
}
